import { ChangeEvent, Dispatch, SetStateAction } from 'react'
import styles from './styles.module.scss'

export interface SliderProps {
  value: number
  setValue: Dispatch<SetStateAction<number>>
  inputMinValue: number
  inputMaxValue: number
}

const STEP_VALUE = 0.1

export const Slider = (props: SliderProps) => {
  const { value, setValue, inputMinValue, inputMaxValue } = props

  return (
    <div className={styles.container}>
      <div
        className={styles.decrease}
        onClick={() => setValue((value) => value - STEP_VALUE)}
      >
        -
      </div>

      <input
        type="range"
        value={value}
        min={inputMinValue}
        max={inputMaxValue}
        step={STEP_VALUE}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setValue(Number(e.target.value))
        }
        aria-label="slider-input"
      />
      <div
        className={styles.increase}
        onClick={() => setValue((value) => value + STEP_VALUE)}
      >
        +
      </div>
    </div>
  )
}

export default Slider
